import moment from 'moment'

const LaunchTooltip = props => {
  return (
    <g style={props.style}>
      <rect
        x={props.viewBox.x - 70}
        y={props.viewBox.y}
        fill="#2158CF"
        width={140}
        height={26}
        rx="15"
      />
      <text
        x={props.viewBox.x}
        y={props.viewBox.y - 6}
        dominant-baseline="middle"
        text-anchor="middle"
        fill="#FFFFFF"
        dy={20}
        dx={0}
        fontSize={11}
        fontWeight={500}
      >
        Launch - {moment(props.serviceStartDate).format('MMM DD, YYYY')}
      </text>
    </g>
  )
}

export default LaunchTooltip
